import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { TenantConfigStore } from '../../../shared/stores/tenant-config.store';
import { AppNavigationService } from '../../../core/services/app-navigation.service';

/**
 * Route guard that prevents access to disclosure features when the
 * Form Builder module is disabled for the tenant (formBuilderEnabled === false).
 * Applied to /disclosures and /form/:disclosureId routes.
 */
export const disclosureModuleGuard: CanActivateFn = () => {
  const tenantConfigStore = inject(TenantConfigStore);
  const appNav = inject(AppNavigationService);

  if (!tenantConfigStore.formBuilderEnabled()) {
    return appNav.createUrlTree('/home');
  }
  return true;
};
